// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ApprovalStatus = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
} as const;
export type ApprovalStatus = typeof ApprovalStatus[keyof typeof ApprovalStatus];


export function instanceOfApprovalStatus(value: any): boolean {
    for (const key in ApprovalStatus) {
        if (Object.prototype.hasOwnProperty.call(ApprovalStatus, key)) {
            if (ApprovalStatus[key as keyof typeof ApprovalStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApprovalStatusFromJSON(json: any): ApprovalStatus {
    return ApprovalStatusFromJSONTyped(json, false);
}

export function ApprovalStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprovalStatus {
    return json as ApprovalStatus;
}

export function ApprovalStatusToJSON(value?: ApprovalStatus | null): any {
    return value as any;
}

export function ApprovalStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ApprovalStatus {
    return value as ApprovalStatus;
}
